import React from 'react';

import {PriceFormat} from '../../common';

export default function ConversionSummary({
    stepData
}) {
    /* Constants */
    const { brand, constructionYear, financePrice, fuel, imageUrl, mileage, model, price, type } = stepData?.data?.additionalData?.vehicle || {};

    /* Render */
    return (
        <div className="card card--product">
            {imageUrl && (
                <div className="card__header">
                    <img className="card__image img-fluid" src={imageUrl} alt={`${brand} ${model}`} width="320" height="240" loading="lazy" />
                </div>
            )}
            <div className="card-body d-flex flex-column position-relative">
                <p className="h6 mb-1">{brand} {model}</p>
                <p className="card__text mb-3 text-truncate">{type}</p>
                <div className="row gutters-4">
                    {constructionYear && (
                        <div className="col-auto">
                            <span className="card__text text-nowrap">{constructionYear}</span>
                        </div>
                    )}
                    {fuel && (
                        <div className="col-auto">
                            <span className="card__text text-nowrap">{fuel}</span>
                        </div>
                    )}
                    {mileage && (
                        <div className="col-auto">
                            <span className="card__text text-nowrap">{new Intl.NumberFormat('nl-NL').format(mileage)} km</span>
                        </div>
                    )}
                </div>
                <hr className="card__border my-2 pb-2" />
                <div className="row gutters-3">
                    {price && (
                        <div className="col-6">
                            <p className="card__text mb-0">Kopen</p>
                            <PriceFormat className="card__price" value={price} />
                        </div>
                    )}
                    {financePrice && (
                        <div className="col-6">
                            <p className="card__text mb-0">Financieren</p>
                            <PriceFormat className="card__price" value={financePrice} />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
